import { useEffect, useRef, useState } from 'react';

export function useIsWrapped<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T | null>(null);
  const [isWrapped, setIsWrapped] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkWrap = () => {
      const children = Array.from(el.children) as HTMLElement[];
      if (children.length < 2) {
        setIsWrapped(false);
        return;
      }
      const firstTop = children[0].offsetTop;
      const hasWrapped = children.some(child => child.offsetTop !== firstTop);
      setIsWrapped(hasWrapped);
    };

    const observer = new ResizeObserver(checkWrap);
    observer.observe(el);
    checkWrap();

    return () => observer.disconnect();
  }, []);

  return { ref, isWrapped };
}
